import { OrmModel, StringField } from 'vuex-orm-decorators'
import BaseModel from '@/data/models/BaseModel'
import { modelNames } from '@/data/models/types'

@OrmModel(modelNames.MEDIA_DEVICE)
export default class MediaDevice extends BaseModel {
  @StringField()
  public id: MediaDeviceKind

  @StringField('')
  public deviceId: string
}
